<template>
  <login-container>
    <find-tab />
    <form
      @submit.prevent="login"
      @input="error.errorMessage = ''"
    >
      <find-title
        labeltitle="회원정보에 등록한 이메일로 인증"
        labeltext="회원정보에 등록한 이메일과 입력한 이메일이 같아야 계정 안내를 받을 수 있습니다."
      ></find-title>

      <div class="find__email">
        <form-input
          type="email"
          placeholder="이메일을 입력해 주세요"
          class="form-input--lg"
          v-model="user.email"
          name="email"
          :error="error"
        ></form-input>
      </div>

      <div class="pt--40px pb--24px">

        <form-button
          :disabled="disabled"
          type="submit"
          label="아이디 확인"
          class="btn btn--block btn--xxxl black text--white"
        ><img
            src="../../../../static/img/spinner.gif"
            class="btn"
            alt=""
            v-if="disabled"
          ></form-button>
      </div>

      <div class="text--center">
        <p class="text--gray darken--2 font--12px">
          이미 아이디가 있으신가요?
          <a
            @click="$router.push({name: 'login'})"
            class="text--black ml--4px font--12px"
          >로그인</a>
        </p>
      </div>
    </form>

  </login-container>
</template>

<script>
export default {
  data () {
    return {
      user: {
        email: ''
      },
      error: {},
      disabled: false
    }
  },
  methods: {
    async login () {
      if (this.disabled) {
        return
      }
      this.disabled = true
      try {
        await this.$http.post('/api/auth/findby/email', this.user)
        alert('메일 발송에 성공하였습니다. 메일을 확인해 주세요')
        this.$router.push({ name: 'home' })
      } catch (ex) {
        if (ex.response) {
          const { fieldId, errorMessage } = ex.response.data
          this.error = { fieldId, errorMessage }
        }
        alert('메일 발송에 실패하였습니다. 관리자에게 문의해 주세요')
        console.log('err', ex.response.data)
      } finally {
        this.disabled = false
      }
    }
  },
  components: {
    FindTab: () => import('./component/FindTab'),
    FindTitle: () => import('./component/FindTitle'),
    LoginContainer: () => import('@/component/container/LoginContainer'),
    FormInput: () => import('@/component/ui2/form/FormInput'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
